import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { sortOrderActions } from "./actions";
import { SortOrderState } from "./types";

const initialState: SortOrderState = {
  sortOrders: [],
};

export function sortOrderReducer(
  state = initialState,
  action: Action,
): SortOrderState {
  if (isType(action, sortOrderActions.getSortOrder.done)) {
    return {
      ...state,
      sortOrders: action.payload.result,
    };
  }

  return state;
}
